import { connect } from 'react-redux';

import JSX from '../Report';

const mapStateToProps = (state) => ({
    session: state.session
});

export default connect(mapStateToProps)(JSX);
